module.exports = __webpack_public_path__ + "static/media/artez.12451109.png";